var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('div',{staticClass:"back-link"},[_c('router-link',{attrs:{"to":{name: 'index'}}},[_c('i',{staticClass:"icon-chevron"}),_vm._v("Back")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }